import { useState, useEffect } from "react";
import BookingForm from "../components/BookingForm";
import physic from "../assets/images/first1.png";

const MetaForm = () => {

   const [formData, setFormData] = useState({
      user_name: "",
      user_phone: "",
      city: "Mumbai",
      pinCode: "",
    });
  const handleBackButtonClick = () => {
    setFormData({
      user_name: "",
      user_phone: "",
      city: "",
      pinCode: "",
    });
    // Redirect to the main website
    window.location.href = "https://www.physica.fit";
  };
  return (
    <div className="flex flex-col flex justify-center md:w-1/2 md:mx-auto">
    {/* Image at the top of the page */}
    <div
          className="cursor-pointer"
          style={{ padding: "10px", paddingLeft: "22px" }}
          onClick={handleBackButtonClick}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 16 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.10841 0.228163C7.39181 0.531457 7.39082 1.02214 7.10619 1.32413L2.48697 6.22512H15.2727L15.3714 6.2322C15.7264 6.28351 16 6.60775 16 7.00009C16 7.42809 15.6744 7.77505 15.2727 7.77505H2.48848L7.10624 12.6759L7.17682 12.7627C7.38866 13.0656 7.36602 13.4962 7.10837 13.7719C6.82494 14.0752 6.36446 14.0762 6.07986 13.7742L0.213264 7.5486L0.210346 7.54501C0.187782 7.5207 0.166718 7.49481 0.147311 7.4675L0.142491 7.46157C-0.0698261 7.15771 -0.046217 6.72568 0.213306 6.45032L6.0799 0.225803L6.16162 0.150955C6.44679 -0.0734968 6.85077 -0.0475585 7.10841 0.228163Z"
              fill="#393938"
            />
          </svg>
        </div>
    <img src={physic} className="w-full" alt="image not found" />
    {/* Render the BookingForm component */}
    <BookingForm formTypeProp="meta" />
  </div>
  );
};

export default MetaForm;
